"use strict";

exports.createdStores = [];

exports.createdActions = [];

exports.reset = function () {
    while (exports.createdStores.length) {
        exports.createdStores.pop();
    }
    while (exports.createdActions.length) {
        exports.createdActions.pop();
    }
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/reflux/~/reflux-core/lib/Keep.js
 ** module id = 89
 ** module chunks = 0
 **/